if (!customElements.get('dynamic-reveal')) {
  customElements.define(
    'dynamic-reveal',
    class DynamicReveal extends window.BAO.CustomElement {
      constructor() {
        super()
      }

      connectedCallback() {
        super.connectedCallback()

        this.isTicking = false
        this.lastKnownY = window.scrollY

        this.requestTick = this.requestTick.bind(this)
        this.updateEl = this.updateEl.bind(this)

        this.updateEl()
      }

      setupListeners() {
        super.setupListeners()

        this.onScroll = this.onScroll.bind(this)

        window.addEventListener('scroll', this.onScroll, { passive: true })
      }

      onScroll() {
        this.lastKnownY = window.scrollY

        this.requestTick()
      }

      requestTick() {
        if (!this.isTicking) requestAnimationFrame(this.updateEl)

        this.isTicking = true
      }

      updateEl() {
        this.isTicking = false

        this.handleScroll()
      }

      handleScroll() {
        const imagesEl = this.querySelector('[data-dynamic-reveal-el="images"]')

        const leftImageEl = this.querySelector('[data-dynamic-reveal-el="left-image"]')
        const centerImageEl = this.querySelector('[data-dynamic-reveal-el="center-image"]')
        const rightImageEl = this.querySelector('[data-dynamic-reveal-el="right-image"]')

        const containerOffsetTop = getOffsetTop(imagesEl)
        const elementStartPoint = containerOffsetTop - window.innerHeight / 2
        const elementEndPoint = (containerOffsetTop + (imagesEl.offsetHeight / 2)) - window.innerHeight / 2

        const percentToStart = 60
        const percentToMove = 30
        const amountToScale = 0.1

        if (this.lastKnownY <= elementStartPoint) {
          if (leftImageEl) {
            leftImageEl.style.transform = `translateX(${percentToStart}%)`
          }
          if (centerImageEl) {
            centerImageEl.style.transform = `scale(1)`
          }
          if (rightImageEl) {
            rightImageEl.style.transform = `translateX(-${percentToStart}%)`
          }

          return
        }

        if (this.lastKnownY > elementEndPoint) {
          if (leftImageEl) {
            leftImageEl.style.transform = `translateX(${percentToStart - percentToMove}%)`
          }
          if (centerImageEl) {
            centerImageEl.style.transform = `scale(${1 + amountToScale})`
          }
          if (rightImageEl) {
            rightImageEl.style.transform = `translateX(-${percentToStart - percentToMove}%)`
          }

          return
        }

        const totalScrollAmount = elementEndPoint - elementStartPoint

        const scrollYAsAPercentageOfJourney =
          (this.lastKnownY - elementStartPoint) / totalScrollAmount

        const transformAmount = percentToMove * scrollYAsAPercentageOfJourney
        const scaleAmount = 1 + (amountToScale * scrollYAsAPercentageOfJourney)

        if (leftImageEl) {
          leftImageEl.style.transform = `translateX(${percentToStart - transformAmount}%)`
        }
        if (centerImageEl) {
          centerImageEl.style.transform = `scale(${scaleAmount})`
        }
        if (rightImageEl) {
          rightImageEl.style.transform = `translateX(-${percentToStart - transformAmount}%)`
        }
      }
    }
  )
}